import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, Select, Checkbox, Button, Popconfirm, Modal } from 'hljd'
import Styles from './style.module.less'
import DepositPaid from '../DepositPaid'
import { observer } from 'mobx-react'
import store from '../store'

const Item = Form.Item
const Option = Select.Option
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 15 }
}

@observer
export default class extends Component {
  state = {
    visible: false
  }

  componentDidMount() {
    store.getH()
  }

  handleCancel = e => {
    this.setState({
      visible: false
    })
  }
  render() {
    let { DataHistory, sendData } = store
    let historyHtml
    if (DataHistory.length != 0) {
      historyHtml = DataHistory.map(v => {
        let _hsp = '暂无'
        if (v.merchant && v.merchant.hotel_saler_setup.length > 0) {
          _hsp = v.merchant.hotel_saler_setup[0].fullname
        }

        let _html = (
          <dl key={v.id} className={v.call_result == '1' ? '' : Styles.noPhone}>
            <dt>
              {v.created_at || ''}
              {v.call_result == '1' ? '' : '（拨打未接通）'}
            </dt>
            <dd>
              <span>{_hsp}</span>
              <p>{v.message}</p>
            </dd>
          </dl>
        )

        return _html
      })
    } else {
      historyHtml = <div className={Styles.noData} />
    }

    return (
      <div className={Styles.FollowUp}>
        <Form>
          <Item {...layout} />
          <Item {...layout} required label="跟进内容">
            <Input
              onChange={store.getMessage}
              type="textarea"
              value={sendData.message}
              placeholder="请输入内容"
            />
          </Item>
          <Item {...layout} required label="客户意向">
            <Select
              onChange={store.getIntent_level}
              value={sendData.intent_level}
              placeholder="类型"
            >
              <Option value="3">高</Option>
              <Option value="2">中</Option>
              <Option value="1">低</Option>
            </Select>
          </Item>
          <Item {...layout} label="拨打未接通">
            <Checkbox
              checked={sendData.call_result == '1' ? false : true}
              onChange={store.getCall_result}
            />
          </Item>
        </Form>
        <div className={Styles.ButtonSend}>
          <Button
            style={{
              width: 282,
              lineHeight: '32px',
              fontSize: '16px',
              height: 32
            }}
            onClick={store.sendAjax}
            type="primary"
          >
            提交
          </Button>
        </div>
        <div className={Styles.FollowUp_col}>
          <h5>历史跟进记录</h5>
          <div className={Styles.Fcol}>{historyHtml}</div>
          <div style={{ display: 'none' }} className={Styles.areaBtn}>
            <Popconfirm
              title="是否确定客户跟进失败?"
              onConfirm={store.sendFail}
              okText="确定"
              cancelText="取消"
            >
              <Button
                style={{ width: 90, marginRight: 8, marginLeft: 13 }}
                type="ghost"
              >
                跟进失败
              </Button>
            </Popconfirm>
            <Button style={{ width: 90, marginRight: 8 }} type="ghost">
              定金已付
            </Button>
            <Button
              style={{ width: 90 }}
              onClick={store.sendCome}
              type="primary"
            >
              确认到店
            </Button>
          </div>
        </div>
        <Modal
          visible={this.state.visible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <DepositPaid />
        </Modal>
      </div>
    )
  }
}
